import {
  ApplicantUserProfessionalInput,
  ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateDocument,
  ApplicantPrimaryEducationDetailsContainerApplicantUserDocument,
  ApplicantPrimaryEducationDetailsContainerEntitiesDocument,
  Entity,
  ApplicantUserProfessional
} from '../../../../generated';
import { useProfileSubmissionCheck } from '../../../shared/use-profile-submission-check';
import { lookupCountryQuery } from './primary-education-country-query';
import { useMutation, useQuery } from '@apollo/client';
import { App } from 'antd';
import { PrimaryEducationDetails } from './primary-education-details';
import { Country } from '../../../../types/country';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { FC } from 'react';

interface PrimaryEducationDetailsContainerProps {
  applicantUserId: string;
}

export const PrimaryEducationDetailsContainer: FC<PrimaryEducationDetailsContainerProps> = (props) => {
  const { message } = App.useApp();
  const {
    data,
    loading,
    error: primaryEducationDetailsError
  } = useQuery(ApplicantPrimaryEducationDetailsContainerApplicantUserDocument, {
    variables: {
      applicantUserId: props.applicantUserId
    }
  });
  const { data: countryData, loading: countryLoading, error: countryError } = useQuery(lookupCountryQuery);
  const [applicantUserUpdate] = useMutation(ApplicantPrimaryEducationDetailsContainerApplicantUserUpdateDocument);

  const { data: entityData, loading: entityLoading, error: entityError } = useQuery(ApplicantPrimaryEducationDetailsContainerEntitiesDocument);

  useProfileSubmissionCheck(data, props.applicantUserId as string);

  const onSave = async (values: ApplicantUserProfessionalInput) => {
    try {
      const result = await applicantUserUpdate({
        variables: {
          input: {
            id: props.applicantUserId,
            applicantUserDetails: {
              personalInformation: {
                professional: {
                  ...values
                }
              }
            }
          }
        }
      });
      if (result.data?.applicantUserUpdate.status) {
        message.success('Primary education details saved successfully');
      } else {
        message.error('Failed to save primary education details');
      }
    } catch (error) {
      message.error(`Failed to save primary education details ${JSON.stringify(error)}`);
    }
  };

  const filteredEntityData = entityData?.entities?.filter((entity) => entity?.isIssuingInstitution === true) || [];

  const hasData = data && entityData && countryData;
  const error = primaryEducationDetailsError || entityError || countryError;
  const isLoading = loading || entityLoading || countryLoading;

  return (
    <ComponentQueryLoader
      error={error}
      loading={isLoading}
      hasData={hasData}
      hasDataComponent={
        <PrimaryEducationDetails
          data={data?.applicantUser?.personalInformation?.professional as ApplicantUserProfessional}
          countryData={countryData?.countries?.eventPayload?.countries as Country[]}
          onSave={onSave}
          entities={filteredEntityData as Entity[]}
        />
      }
    />
  );
};

